import { Sparkles } from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="py-12 px-6 border-t border-border">
      <div className="container mx-auto max-w-6xl">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <Sparkles className="w-4 h-4 text-primary" />
            <span className="text-sm text-muted-foreground">Concierge by Kiln</span>
            <Sparkles className="w-4 h-4 text-accent" />
          </div>

          <div className="flex items-center gap-6">
            <Link
              to="/privacy-policy"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Privacy Policy
            </Link>
            <a
              href="https://kiln.com/terms-conditions/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Terms & Conditions
            </a>
            <p className="text-sm text-muted-foreground">
              Your digital community team member
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
